var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 32,
    viewBox: "0 0 20 32",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.41784 21.7327L16.4288 0.269032C16.5616 0.00344209 16.8714 -0.0849414 17.0926 0.0920427C17.7563 0.490434 18.5087 0.888574 19.1724 1.28698C19.438 1.41978 19.5264 1.72956 19.3936 1.95073L7.84302 22.9276C8.41838 23.5913 8.77239 24.4323 8.77239 25.4945C8.77239 26.645 8.24143 27.5302 7.71024 28.3712C7.22347 29.1677 6.69231 30.0087 6.95787 30.9822H16.9595C17.2693 30.9822 17.4905 31.2034 17.4905 31.469C17.4905 31.7346 17.2693 31.9999 16.9595 31.9999H6.55964C3.68296 31.9557 1.78011 30.3182 0.895128 28.3267C0.629537 27.6185 0.452548 26.9106 0.408359 26.2024C0.364168 25.4501 0.496965 24.7421 0.718143 24.1226C1.16072 22.972 2.09009 22.0427 3.41758 21.7329L3.41784 21.7327ZM4.70117 21.5999C5.4977 21.5999 6.33869 21.8211 7.04666 22.2636L18.243 1.90671L17.0038 1.19851L4.70134 21.6L4.70117 21.5999Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheme);
export default __webpack_public_path__ + "static/media/theme.1000b263f05f4bdc349877066f8745b3.svg";
export { ForwardRef as ReactComponent };